import { Component, Input, OnInit } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { FilterService } from 'libs/portal/src/services/filter/filter.service';

@Component({
  selector: 'app-advanced-filter-container',
  templateUrl: './advanced-filter-container.component.html',
  styleUrls: ['./advanced-filter-container.component.scss'],
})
export class AdvancedFilterContainerComponent implements OnInit {
  @Input() deviceFilter: string;
  filter: string;
  ScreenSize = ScreenSize;

  constructor(private filterService: FilterService, public layoutService: LayoutService) {}

  ngOnInit() {
    this.filter = this.deviceFilter;
  }

  search() {
    this.filterService.search();
  }
}
